import { render, staticRenderFns } from "./AssignWork.vue?vue&type=template&id=0d69630e"
import script from "./AssignWork.vue?vue&type=script&lang=js"
export * from "./AssignWork.vue?vue&type=script&lang=js"
import style0 from "./AssignWork.vue?vue&type=style&index=0&id=0d69630e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports